export default __webpack_public_path__ + "static/media/cubbit.dc75d962.png";